import React from 'react'
import { Trans } from '@lingui/macro'
import logo from 'assets/images/logos/think-ntx.png'
import { PAYMENT_PROVIDERS } from 'config'

// This config is based off of think not think-stripe

export const companyInfo = {
  name: 'Think',
  salesPhone: <a href="tel:888-664-2171">888-664-2171</a>,
  phone: '888-923-3633',
  termsLink: 'https://www.thinkenergy.com/terms/',
  privacyPolicyLink: 'https://www.thinkenergy.com/privacy-policy/',
  homepageLink: 'https://www.thinkenergy.com',
  iosAppLink: 'https://itunes.apple.com/us',
  androidAppLink: 'https://play.app.goo.gl/',
  faviconLink: 'https://enroll.thinkenergy.com/think.ico',
  forgotPasswordLink: 'https://myaccount.thinkenergy.com/forgot-password',
  thankYouLink: 'https://www.thinkenergy.com/tx-confirmation',
  thankYouLinkNTX: 'https://www.thinkenergy.com/confirmation',
  thankYouLinkCommunitySolar: 'https://www.thinkenergy.com/cs-enrollment-confirmation/',
  thankYouLinkAgency: 'https://www.thinkenergy.com/confirmation-as/',
  chaseMerchantID: '441193',
  chaseSubscriberID: '100000000325',
  chaseSubscriberID_NTX: '100000000356',
  chasePaymentCssURL:
    'https://frontend-chasepaymenttech.s3.us-west-2.amazonaws.com/form.css',
  paymentProvider: PAYMENT_PROVIDERS.CHASE,
  EFLLink: 'https://think.com/terms/',
  TOSYRACLink: 'https://think.com/terms/',
  customerPortalLink: 'https://myaccount.thinkenergy.com/',
  callingHours: <Trans>(Mon - Fri 7am - 7pm CST)</Trans>,
  customerPortalName: 'MyAccount Portal',
  footerCertificate:
    'Think Energy products by EE REP 2, LLC PUCT Cert 10315 | Marketed by Think+ Network, LLC',
  supportEmail: 'care@thinkenergy.com',
  idVerificationEmail: 'ID_Verification@thinkenergy.com',
  idFailedLink: 'https://www.thinkenergy.com/id-verification/?fullName=&email=',
  idFailedLinkCommercial:
    'https://www.thinkenergy.com/small-comm/?fullName=&businessName=&email=',
  expiration_days: '10',
}

const base = '#2830A6'
const primary = '#42DA80'
const secondary = '#2830A6'
const blue = '#00BCD4'
const gray = '#E5E5E5'
const grayMedium = '#7D8D9E'
const grey = '#999999'
const green = '#7CA51B'
const greenPromo = '#8FAB36'
const error = '#dd2c00'
const neutral1 = '#022135'
const neutral2 = '#7D8D9E'
const neutral3 = '#9DB1C6'
const neutral4 = '#D5DEE5'
const neutral5 = '#F2F3F6'
const white = '#fff'
const footerColor = '#2830A6'
const footerTextColor = 'white'
const darkerPrimary = '#2DBE68' // used for hover effect
const background = '#F3F3F3'
const bannerborderbottom = '#4C53E6 1px solid'
const ratePanel = '#2830A6'
const rateText = '#42DA80'

export const color = {
  background,
  base,
  primary,
  secondary,
  blue,
  gray,
  grayMedium,
  grey,
  green,
  greenPromo,
  error,
  gradient: `linear-gradient(90deg, ${primary}, #f47725)`,
  link: '#646BCA',
  neutral1,
  neutral2,
  neutral3,
  neutral4,
  neutral5,
  white,
  footerColor,
  footerTextColor,
  darkerPrimary,
  transparent: '#ffffff00',
  containerBackground: 'transparent',
  bannerColor: `white`,
  bannerTextColor: secondary,
  bannerborderbottom,
  progressBarColor: '#42DA80',
  progressBarBackground: '#fff',
  buttonTextColor: '#fff',
  buttonColor: primary,
  slider: primary,
  dropdown: base,
  ratePanel,
  rateText,
  offerDetails: secondary,
  offerShortDescription: ratePanel,
  circleCheckBackground: primary,
}

export const assets = {}

export const logoConfig = {
  localPath: 'assets/images/logos/think-ntx.png',
  url: '',
  width: 'auto',
  height: '85px',
  padding: '10px',
  backgroundColor: 'transparent',
  useLocal: true,
  logo,
  progressBarImage: {
    custom: true,
    name: 'think',
    height: '85px',
    width: 'auto',
    stepImageNames: {
      1: 'think-home',
      2: 'think-light',
      3: 'think-lock',
      4: 'think-card',
    },
  },
  header: {
    height: '100px',
    position: 'left',
  },
}

const baseFamily = "'DM Sans', sans-serif"
const customFont = "'DM Sans', sans-serif"

export const font = {
  extraBold: '800',
  semiBold: '600',
  medium: '500',
  normal: '400',
  baseFamily,
  customFont,
  customFamily: `${customFont}, ${baseFamily}`,
}

export const fontFace = ''

export const features = {
  DISPLAY_REFERRAL_NAME: true,
  BACKGROUND: false,
  LOCALE_HEADER: {
    props: {
      position: 'right',
      alignSelf: 'center',
      m: '0px 8px',
    },
  },
  CALL_HEADER: false,
  CALL_FOOTER: true,
  CALL_FOOTER_PHONE: true,
  CALL_FOOTER_EMAIL: true,
  REQUIRE_FULL_SOCIAL:
    process.env.REACT_APP_REQUIRE_FULL_SOCIAL === 'true' ? true : false,
  ONLINE_SUPPORT_STATUS_HEADER: true,
  TRUSTPILOT_HEADER: true,
  V2_THEME: true,
  HEADER: {
    position: 'static',
  },
  ENERGY_SLIDER_DEFAULT: '2',
}
